class SwaggerDetailsTabsEnum {
    static SUMMARY = 'summary';
    static EXAMPLES = 'examples';
    static PARAMETERS = 'parameters';
}

export {SwaggerDetailsTabsEnum}